import React, { useState } from 'react';
import { Copy, Check, MessageCircle } from 'lucide-react';
import { StatusBadge } from '@/components/common/StatusBadge';

interface DashboardHeaderProps {
  fullName?: string | null;
  orgStatus: string;
  orgName?: string | null;
  tierDisplayName: string;
  referralUrl: string;
}

export const DashboardHeader: React.FC<DashboardHeaderProps> = ({
  fullName,
  orgStatus,
  orgName,
  tierDisplayName,
  referralUrl,
}) => {
  const [copiedLink, setCopiedLink] = useState(false);

  const copyReferralUrl = () => {
    navigator.clipboard.writeText(referralUrl);
    setCopiedLink(true);
    setTimeout(() => setCopiedLink(false), 2000);
  };

  const shareWhatsApp = () => {
    const text = encodeURIComponent(
      `Join Conversora — Bangladesh's Leading AI Conversational Commerce Platform: ${referralUrl}`
    );
    window.open(`https://wa.me/?text=${text}`, '_blank');
  };

  return (
    <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-4 pb-6 border-b border-zinc-800/80">
      <div>
        <div className="flex items-center gap-2.5 flex-wrap">
          <h1 className="text-2xl sm:text-3xl font-bold tracking-tight text-white">
            Welcome back, {fullName || 'Partner'}
          </h1>
          <StatusBadge status={orgStatus} size="sm" />
          <span className="text-xs px-2.5 py-0.5 rounded-full bg-indigo-500/10 text-indigo-400 border border-indigo-500/20 font-medium">
            {tierDisplayName}
          </span>
        </div>
        <p className="text-sm text-zinc-400 mt-1">
          Workspace: <span className="text-zinc-200 font-medium">{orgName || 'Primary Account'}</span>{' '}
          • Recommend Conversora and receive monthly recurring revenue
        </p>
      </div>

      <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-2 bg-zinc-900/90 border border-zinc-800 rounded-xl p-2 sm:p-2.5 max-w-md w-full">
        <div className="flex-1 min-w-0 px-2">
          <span className="text-[10px] uppercase font-semibold text-zinc-500 tracking-wider block">
            Your Referral Link
          </span>
          <span className="text-xs font-mono text-indigo-300 truncate block">
            {referralUrl}
          </span>
        </div>
        <div className="flex items-center gap-1.5 shrink-0">
          <button
            type="button"
            onClick={copyReferralUrl}
            className="flex-1 sm:flex-none flex items-center justify-center gap-1.5 px-3 py-1.5 text-xs font-medium bg-indigo-600 hover:bg-indigo-500 text-white rounded-lg transition shrink-0 cursor-pointer shadow-xs"
          >
            {copiedLink ? <Check className="w-3.5 h-3.5" /> : <Copy className="w-3.5 h-3.5" />}
            <span>{copiedLink ? 'Copied' : 'Copy'}</span>
          </button>
          <button
            type="button"
            onClick={shareWhatsApp}
            title="Share via WhatsApp"
            className="p-1.5 bg-emerald-600/10 hover:bg-emerald-600/20 text-emerald-400 border border-emerald-500/20 rounded-lg transition cursor-pointer"
          >
            <MessageCircle className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
};
